<template>
    <div class="main">
        <div class="content-container">
            <div class="content-head">
                <div class="content-head-body">
                    <span>
                        <img class="website-logo" src="/static/img/zhaoqing/肇庆Logo.svg" alt="" @click="gotoIndex">
                        <img class="website-logo" src="/static/img/zhuhai/省平台logo.svg" alt="" style="margin-left: 5px;" @click="gotoIndex">
                    </span>
                    <span>
                         <span class="menu-item" :class="{menuActive:active==item.navCode}"
                               v-for="(item, index) in menuList">
                            <a href="javascript:void(0);" @click="gotoUrl(item)">{{ item.navName }}</a>
                         </span>
                    </span>
                </div>


            </div>
            <router-view v-slot="{ Component }">
                <keep-alive>
                    <component :is="Component" v-if="$route.meta.keepAlive"/>
                </keep-alive>
                <component :is="Component" v-if="!$route.meta.keepAlive"/>
            </router-view>
        </div>
<!--        <Footer class="bottom-element"></Footer>-->
    </div>
</template>

<script setup>

import { useRoute } from 'vue-router'
import {getCurrentInstance, onMounted, ref,watch} from 'vue';
const {proxy} = getCurrentInstance();


console.log('设置站点类型')
// 设置分站标识为 'zhaoqing'
proxy.$store.commit('setSiteType', {siteType: proxy.$enumVals.SiteTypeEnum.ZHAOQING.type});
console.log('当前站点标识：', proxy.$store.state.siteType)


const active = ref('index');
const menuList = ref([]);

const gotoUrl = (item) => {
    if(item.navCode === 'logoutFunc'){
        //退出登录
        gotoLogout();
    }else{
        active.value = item.navCode;
        proxy.$router.push({path: item.navCode});
    }


}

const gotoIndex = () => {
    proxy.$router.push({path: '/zhaoqing/index'});
}

//退出登录
const gotoLogout = () => {
    proxy.$http.post('/core/base/c/index/logout').then(res => {
        if (res.data.state == 0) {
            proxy.$store.commit('updateLoginStatus', {token: ''});
            proxy.$store.commit('updateUserInfo', {userInfo: '{}'});

            // 获取分站类型
            const siteType = proxy.$store.state.siteType;
            if(siteType == proxy.$enumVals.SiteTypeEnum.ZHUHAI.type){
                // 跳转至珠海
                proxy.$router.push({name: 'ZhuhaiMain', path: '/zhuhai'});
            }else if(siteType == proxy.$enumVals.SiteTypeEnum.ZHAOQING.type){
                // 跳转至肇庆
                proxy.$router.push({name: 'ZhaoqingMain', path: '/zhaoqing'});
            }else{
                proxy.$router.push({name: 'Index', path: '/'});
            }
            setTimeout(function () {
                window.location.reload();
            }, 100);
            // location.reload();
        }
    }).catch(err => {

    });
}


//设置菜单最后两项，若已登录，显示跳转我的控制台和退出登录菜单，若未登录显示登录和注册
const setLoginMenu = () => {
    menuList.value = [
        {
            navCode: '/zhaoqing/index',
            navName: '首页'
        },
        {
            navCode: '/zhaoqing/zhaoqingResRetrieve',
            navName: '科研仪器'
        },
        {
            navCode: '/zhaoqing/zhaoqingPlatform',
            navName: '实验室与平台基地'
        },
        {
            navCode: '/zhaoqing/zhaoqingAbout',
            navName: '关于我们'
        },
    ];
    if (proxy.$store.state.userInfo && proxy.$store.state.userInfo.userName) {
        //已登录
        menuList.value.push(
            {
                navCode: '/zhaoqing/zhaoqingUser',
                navName: '我的控制台'
            },
            {
                navCode: 'logoutFunc',
                navName: '退出登录'
            }
        );
    }else{
        //未登录
        menuList.value.push(
            {
                navCode: '/zhaoqing/zhaoqingLogin',
                navName: '登录'
            },
            {
                navCode: '/zhaoqing/zhaoqingRegister',
                navName: '注册'
            }
        );
    }

}

onMounted(()=>{


    setLoginMenu();
})

const route = useRoute() // 获取当前路由对象
// 监听路由变化：只要路由跳回当前页面，就执行
watch(
    () => route.path, // 监听路由路径
    () => {
        setLoginMenu();
    },
    { immediate: false } // 不需要立即执行，首次已经由onMounted执行
)


</script>

<style scoped lang="less">
.main {
    width: 100%;
    height: 100vh;
    /* 设置父元素为flex布局, 实现《页面高度不足时，在底部显示；页面高度超出时，随页面滚动》 */
    display: flex;
    /* 设置子元素的排列方向为垂直 */
    flex-direction: column;
    /* 设置子元素在该方向上的对齐方式 */
    justify-content: space-between;

    background-color: #F6F9FF;
}
.content-container{
    background-image: url('/static/img/zhaoqing/新-顶部图片背景-大.png');
    //background-image: url('/static/img/zhaoqing/新-顶部图片背景-大.jpg');
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: 0px 55px;
    background-color: #F6F9FF;
}
.menu-item {
    //height: 100%;
    padding: 14px 10px;
}

.menuActive {
    border-bottom: 3px solid #fff;

}

.menu-item a {
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #fff;
    letter-spacing: 0;
    text-align: justify;
    text-decoration: none;


}

.menu-item.active a {
    color: #fff;
}

.menu-item a:hover {
    color: #ccc;
}

.content-head {
    height: 55px;
    background-color: #1EB38A;
    display: flex;
    justify-content: center;
}
.content-head-body{
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.website-logo:hover{
    cursor: pointer;
}

</style>

